import Box from "@mui/material/Box";
import { Text } from "@fluentui/react";
import { TextField, type ITextFieldStyles } from "@fluentui/react/lib/TextField";
import { Label } from "@fluentui/react/lib/Label";
import * as React from "react";
import { EquipmentDropdown } from "./EquipmentDropdown";
import type { FtlPanelFormData } from "./ftlFormModel";
import { styles } from "./FTL.styles";

export function FtlShipmentWeightEquipmentFields({
  formData,
  errors,
  weightWarning,
  equipmentOptions,
  onInputChange,
  onPersistBlur,
  getTextFieldStyles,
  onSelectEquipment,
}: {
  formData: FtlPanelFormData;
  errors: Record<string, string>;
  weightWarning?: string;
  equipmentOptions: string[];
  onInputChange: (
    event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    newValue?: string
  ) => void;
  onPersistBlur: () => void;
  getTextFieldStyles: (fieldName: string) => Partial<ITextFieldStyles>;
  onSelectEquipment: (equipment: string) => void;
}): React.ReactElement {
  return (
    <>
      <Box>
        <TextField
          label="Weight (lbs)"
          name="weight"
          value={String(formData.weight)}
          onChange={onInputChange}
          onBlur={onPersistBlur}
          styles={getTextFieldStyles("weight")}
          errorMessage={errors.weight}
        />
        {weightWarning && !errors.weight && (
          <Text
            styles={{
              root: {
                fontSize: "12px",
                color: "#e5a100",
                marginTop: "4px",
                display: "block",
              },
            }}
          >
            {weightWarning}
          </Text>
        )}
      </Box>
      <Box sx={styles.fieldWrap}>
        <Label required>Equipment</Label>
        <EquipmentDropdown
          value={formData.equipment}
          onChange={onSelectEquipment}
          options={equipmentOptions}
          errorMessage={errors.equipment}
        />
      </Box>
    </>
  );
}
